import {
  ADD_TO_SERVICE_LIST,
  REMOVE_FROM_SERVICE_LIST,
  CLEAR_SERVICE_LIST,
} from "../actions/ServiceListActions";

const initialState = {
  services: [],
};

const ServiceListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_SERVICE_LIST: {
      const updatedServices = state.services.filter(
        (service) => service.code !== action.payload.code
      );
      return {
        ...state,
        services: [...updatedServices, action.payload],
      };
    }

    case REMOVE_FROM_SERVICE_LIST: {
      const filteredServices = state.services.filter(
        (service) => service.code !== action.payload
      );
      return {
        ...state,
        services: filteredServices,
      };
    }

    case CLEAR_SERVICE_LIST:
      return initialState;

    default:
      return state;
  }
};

export default ServiceListReducer;
